import { v4 as uuidv4 } from "uuid";

export const generateUniqueId = (suffix?: string, hash?: string) => {
    const uniqueHash = hash || uuidv4();
    const prefix = `atlas-${uniqueHash}`;
    const suffixWithId = suffix ? `${suffix}-id` : "id";
    return `${prefix}-${suffixWithId}`;
};
